export const USER_AVATAR_UPDATED_EVENT = 'fongpt-user-avatar-updated';
export const MAX_USER_AVATAR_BYTES = 1024 * 1024;

const SUPPORTED_AVATAR_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp'
]);

export function userAvatarStorageKey(identifier: string): string {
  return `fongpt-user-avatar:${identifier.trim().toLowerCase()}`;
}

export function getUserInitials(
  displayName?: string | null,
  identifier?: string | null
): string {
  const name = displayName?.trim();
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    return `${parts[0]?.[0] || ''}${parts.length > 1 ? parts.at(-1)?.[0] || '' : ''}`.toUpperCase();
  }

  const accountName = identifier?.split('@')[0]?.trim();
  return accountName?.[0]?.toUpperCase() || 'U';
}

export function getStoredUserAvatar(identifier?: string | null): string | null {
  if (!identifier) return null;
  return window.localStorage.getItem(userAvatarStorageKey(identifier));
}

export function saveStoredUserAvatar(identifier: string, dataUrl: string): void {
  window.localStorage.setItem(userAvatarStorageKey(identifier), dataUrl);
  window.dispatchEvent(new Event(USER_AVATAR_UPDATED_EVENT));
}

export function removeStoredUserAvatar(identifier: string): void {
  window.localStorage.removeItem(userAvatarStorageKey(identifier));
  window.dispatchEvent(new Event(USER_AVATAR_UPDATED_EVENT));
}

export function validateUserAvatarFile(file: Pick<File, 'size' | 'type'>): void {
  if (!SUPPORTED_AVATAR_TYPES.has(file.type)) {
    throw new Error('unsupported-type');
  }
  if (file.size > MAX_USER_AVATAR_BYTES) {
    throw new Error('file-too-large');
  }
}

export function fileToDataUrl(file: File): Promise<string> {
  validateUserAvatarFile(file);
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () =>
      typeof reader.result === 'string'
        ? resolve(reader.result)
        : reject(new Error('read-failed'));
    reader.onerror = () => reject(new Error('read-failed'));
    reader.readAsDataURL(file);
  });
}
